module.exports = __webpack_public_path__ + "img/goal_grey.f9617677.svg";